// LICENSE_CODE ZON
/*jslint browser:true, es6:true, node:true, react:true*/
import React, {useEffect, useRef} from 'react';
import cn from 'classnames';
import {use_theme} from '../../../../hola/pub/settings_ctx';
import Icon_trustpilot from '../../img/icons/trustpilot_star.svg';
import Icon_trustpilot_star from '../../img/icons/trustpilot_star_white.svg';

import styles from './trustpilot_widget.module.less';

export const Trustpilot_widget = ()=>{
    const domain = `oculusproxies.com${location.pathname}`;
    const trustpilot_url = `https://www.trustpilot.com/review/${domain}`;
    const height = 20;
    const width = 300;
    const trustbox_ref = useRef(null);
    const widget_id_ref = useRef(`trustbox_${Date.now()}_${Math.random()
        .toString(36).substring(2, 11)}`);
    const is_trustpilot_ready = ()=>{
        return window.Trustpilot && window.Trustpilot.loadFromElement;
    };
    const load_trustpilot_widget = ()=>{
        if (is_trustpilot_ready() && trustbox_ref.current)
        {
            try {
                window.Trustpilot.loadFromElement(trustbox_ref.current);
            } catch {
                setTimeout(()=>{
                    if (is_trustpilot_ready() && trustbox_ref.current)
                    {
                        window.Trustpilot
                            .loadFromElement(trustbox_ref.current);
                    }
                }, 500);
            }
        }
    };
    const check_trustpilot = ()=>{
        if (is_trustpilot_ready())
            load_trustpilot_widget();
        else
            setTimeout(check_trustpilot, 100);
    };
    useEffect(()=>{
        const widget_id = widget_id_ref.current;
        if (trustbox_ref.current)
            trustbox_ref.current.id = widget_id;
        let script = document.querySelector('script[src="https://widget.' +
            'trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"]');
        let script_el: HTMLScriptElement;
        if (!script)
        {
            script_el = document.createElement('script');
            script_el.src = 'https://widget.trustpilot.com/bootstrap/v5/' +
                'tp.widget.bootstrap.min.js';
            script_el.async = true;
            document.head.appendChild(script_el);
            script_el.onload = ()=>setTimeout(load_trustpilot_widget, 200);
        }
        else if (is_trustpilot_ready())
            setTimeout(load_trustpilot_widget, 100);
        else
            check_trustpilot();
        let existing_schema_script = document.querySelector('script[type=' +
            '"application/ld+json"]');
        if (!existing_schema_script)
        {
            const schema_script: HTMLScriptElement =
                document.createElement('script');
            schema_script.type = 'application/ld+json';
            schema_script.text = JSON.stringify({
                '@context': 'http://schema.org',
                '@type': 'Organization',
                name: 'Oculus Proxies',
                url: `https://www.${domain}`,
                aggregateRating: {
                    ratingValue: '4.2',
                    reviewCount: '67',
                    bestRating: '5',
                    worstRating: '1',
                },
                sameAs: [trustpilot_url],
            });
            document.head.appendChild(schema_script);
        }
        return ()=>{
            const trustbox = document.getElementById(widget_id);
            if (trustbox)
                trustbox.innerHTML = '';
        };
    }, [domain]);
    return <div style={{height: `${height}px`, width: `${width}px`}}>
      <div
        ref={trustbox_ref}
        className='trustpilot-widget'
        data-locale='en-US'
        data-template-id='5419b732fbfb950b10de65e5'
        data-businessunit-id='65e87600c8ba4ca744f81e9f'
        data-style-height={`${height}px`}
        data-style-width='100%'
        data-schema-type='Organization'>
        <a href={trustpilot_url} target='_blank' rel='noopener noreferrer'></a>
      </div>
    </div>;
};

export const Trustpilot_custom_widget = ()=>{
    const {theme} = use_theme();
    return <div className={styles.tp_custom_widget}>
      <p className={cn(theme.p12, theme.bold)}>Great</p>
      <div className={styles.tp_stars}>
        {Array.from({length: 5}).map((_, i)=>{
          return <div key={'star_' + i}
            className={i < 4 ? styles.tp_green : styles.tp_grey}>
            <Icon_trustpilot_star/>
          </div>;
        })}
      </div>
      <div className={styles.tp_logo}>
        <Icon_trustpilot/>
        <p className={cn(theme.p12, theme.med)}>Trustpilot</p>
    </div>
    </div>;
};
